export default "__VITE_ASSET__DixsMbpU__"